export enum CalculationDifficultyOptions {
  Off = 0,
  Easy = 1,
  Medium = 2,
  Hard = 3,
}
